<template>
  <div id="mallAmount3">

      <div class="d-flex pt-2 pl-2">
        <span class="icon-cube" style="color:#5cd9e8;font-size: 0.3rem;width: 100%">
           <span class="fs-xl text mx-2" style="font-size: 0.25rem;color: #ffffff">科技人才岗位分布</span>
        </span>

      </div>
      <div class="d-flex" style="width: 100%;height:calc(100% - 0.5rem);margin-top: 0.5rem;">
        <Echart id="mallAChart3" style="width: 100%;height:100%;"></Echart>
      </div>
    </div>

</template>

<script>
// import centerRight2Chart1 from "@/components/echart/centerRight/centerRightChart";
import Echart from '@/common/echart'
import sciApi from '@/api/index.js'
let Chart
export default {
  data() {
    return {
      tag:'',
      options:{},
      Num:{

        '管理层':0,
        '技术人员':0,
      },
      // Num:{
      //   '副高':0,
      //   '管理层':0,
      //   '剩下职工':0,
      //   // '2015':0,
      //   // '2016':0,
      //   // '2017':0,
      //   // '2018':0,
      //   // '2019':0,
      //   // '2020':0,
      //   // '2021':0,
      //   // '2022':0,
      // },
      deList:[],
      allAmount:0,
      allAmountList:{},
    };
  },
  components: {
    Echart
  },
  watch:{
    setregion3:{
      immediate: true,
      deep: true,
      handler(val) {
        this.tag = val

      },
    },
    // tag:{
    //   immediate: false,
    //   deep: true,
    //   handler(val) {
    //     console.log(val,'val')
    //     this.init().then(()=>{
    //       // let num= Object.values(this.Num)
    //       // this.options.series[0].data=num
    //       this.options.series[0].data=this.Num
    //       Chart.setOption(JSON.parse(JSON.stringify(this.options)),true);
    //     })
    //   },
    // },
  },
  computed:{
    setregion3() {
      return this.$store.state.region3
    }
  },
  // components: { centerRight2Chart1 },
  mounted() {
    this.tag=''
    // const chartTit = Object.keys(this.Num);
    this.init().then(()=>{
      // let num= Object.values(this.Num)
      // console.log(num,'num')
      let num=[]
      for (let key in this.Num){
        num.push({ name:key,
          value:this.Num[key]})
      }
      this.options.series[0].data= num
      Chart.setOption(JSON.parse(JSON.stringify(this.options)),true);
    })
    //当前视口宽度
    let nowClientWidth = document.documentElement.clientWidth;
    // 换算方法
    let nowSize = function (val, initWidth = 1920) {
      return val * (nowClientWidth / initWidth);
    };
    this.options = {
      color: [
        // "#37a2da",
        // "#32c5e9",
        // "#9fe6b8",
        "#ffdb5c",
        "#ff9f7f",
        "#fb7293",
        "#e7bcf3",
        "#8378ea"
      ],
      tooltip: {
        trigger: 'item',
        backgroundColor:'#fff',
        textStyle:{
          color:'#3a3a3a',
          align:'left',
          fontSize:nowSize(14)
        },
        // formatter: "{b}<br/>{c}人"
      },
      legend: {
        show:true,
        left:'0',
        type:'scroll',
        orient: 'vertical',
        // textStyle:{
        //   color:"#fff"
        // },
        // left:'left'
      },
      series: [
        {
          name: '科技人才岗位',
          type: 'pie',
           top:'20',
          startAngle: 180,
          // roseType: "area",
          radius: ['50%', '80%'],
          center: ["50%", "50%"],
          avoidLabelOverlap: true,
          label: {
            fontSize:nowSize(14),
            show: true,
            // position: 'outer',
            // alignTo: 'edge',
            // edgeDistance: 10,
            // bleedMargin: 5,
            formatter: "{c}人({d}%)",
            rich: {
              number: {
                fontSize: 18,
                color: '#fff',
              }
            }
          },
          // emphasis: {
          //   label: {
          //     show: true,
          //     fontSize: '28',
          //   }
          // },
          data: [],
        }
      ]
    }
    this.drawLine();

  },
  methods: {
      toThousands(num) {
        return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      },
    async init(){
      // await sciApi.selectMall({})
      //总金额
      await sciApi.selectTalents({pageSize: 1000,pageNum: 1}).then((data)=>{
        // data 就是接口返回值
        // this.Num=[]
        this.Num={
          '管理层':0,
          '技术人员':0,
        },
        this.deList = data.list || []
        this.deList.forEach((item) => {
          if(item.level1Display=='管理层'||item.level1Display=='技术人员'){
            this.Num[item.level1Display] += parseInt(item.mapNum||0 )
          }
        })
        // this.allAmountList = data.employeesProportion || {}
        // this.Num.push({name:'副高',value:this.allAmountList.deputySeniorValues})
        // this.Num.push({name:'管理层',value:this.allAmountList.managementNumValues})
        // this.Num.push({name:'剩下职工',value:this.allAmountList.employeesValue})
        // console.log(this.allAmountList,'this.allAmountList')
        // if(this.tag!==''){
        //   this.allAmountList.forEach((item) => {
        //     if(item.mapAreaDisplay == that.tag)
        //     {
        //       that.Num[item.level3DisplayValue] += parseInt(item.mapNum);
        //     }else {
        //       that.Num[item.level3DisplayValue] = 0;
        //     }
        //   })
        // }else {
        //   this.allAmountList.forEach((item) => {
        //     this.allAmount += parseInt(item.mapNum)
        //     that.Num[item.level3DisplayValue] += parseInt(item.mapNum);
        //   })
        // }
      })

    },
      drawLine:function (){
        Chart = this.$echarts.init(document.getElementById('mallAChart3'))
        Chart.setOption(JSON.parse(JSON.stringify(this.options)));
        // option && myChart.setOption(option);
      },
    },

};
</script>

<style lang="scss">
#mallAmount3 {
  height:100%;
  width: 100%;
  padding: 0.2rem;
  display: flex;
  flex-direction: column;
  //border-radius: 0.0625rem;
  .bg-color-black {
    padding: 0.0625rem;
    height: auto;
    border-radius: 0.125rem;
  }
  .text {
    color: #c3cbde;
  }
  .body-box {
    border-radius: 0.125rem;
    overflow: hidden;
  }
}
</style>